import Slider from 'rc-slider';
import React from 'react';

export const MySlider: React.FC<{
    onChange(val: number): void;
    defaultValue: number;
}> = (props) => {
    let isChange = false;
    return (
        <div>
            <Slider
                min={0}
                max={200}
                defaultValue={props.defaultValue}
                trackStyle={{
                    backgroundColor: '#F14D38',
                    height: 8,
                }}
                railStyle={{
                    backgroundColor: '#403E3D',
                    height: 8,
                }}
                handleStyle={{
                    height: 24,
                    width: 9,
                    backgroundColor: '#FAF8F7',
                    borderColor: 'transparent',
                    borderRadius: 4,
                    marginTop: -8,
                }}
                activeDotStyle={{ borderColor: 'transparent' }}
                onChange={(val) => {
                    if (isChange) {
                        return;
                    }
                    props.onChange(val);

                    // prevent user from changing slider repeatedly
                    isChange = true;
                    setTimeout(() => {
                        isChange = false;
                    }, 300);
                }}
            />
        </div>
    );
};
